<template>
  <div class="job">
    <form @submit.prevent="onSubmit" novalidate>
      <b-field label="Role" custom-class="labelCharge" horizontal>
        <b-select placeholder="Select role" v-model="role" required>
          <option
            v-for="(role, index) in roles"
            :key="index"
            :value="role.name"
          >
            {{ role.name }}
          </option>
        </b-select>
      </b-field>
      <br />
      <br />
      <b-button
        type="is-primary"
        native-type="submit"
        style="margin-right: 10px"
        >Submit</b-button
      >
      <b-button type="is-warning" native-type="button" @click="cancel()"
        >Cancel</b-button
      >
    </form>
  </div>
</template>
<script>
import axios from "axios";

export default {
  name: "RoleForm",
  data() {
    return {
      email: null,
      role: null,
      roles: [{ name: "driver" }, { name: "office" }, { name: "admin" }]
    };
  },
  methods: {
    async onSubmit() {
      const isValid = true;
      if (!isValid) {
        alert("error");
        return;
      }
      this.postUserRole();
      this.$emit("saved");
    },
    cancel() {
      this.$emit("cancelled");
    },
    async postUserRole() {
      try {
        await axios
          .post(
            this.$store.state.apiUrl + "user/role",
            {
              email: this.email,
              role: this.role
            },
            {
              headers: {
                Authorization: "Bearer " + this.$cookies.get("user_token"),
                "Content-Type": "application/json"
              }
            }
          )
          .then(response => {
            console.log(response);
          });
      } catch (error) {
        console.log(error);
      }
    }
  },
  mounted() {
    this.email = this.$store.state.email;
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
